import React, { memo } from "react";

const PodiumLoading = () => {
  return <div style={{ opacity: 0, height: 185.5 }} />;
};

export default memo(PodiumLoading);
